import { render, staticRenderFns } from "./Subtitle.vue?vue&type=template&id=454a1cda&scoped=true&"
import script from "./Subtitle.vue?vue&type=script&lang=ts&"
export * from "./Subtitle.vue?vue&type=script&lang=ts&"
import style0 from "./Subtitle.vue?vue&type=style&index=0&id=454a1cda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454a1cda",
  null
  
)

export default component.exports